import { useState } from 'react';
import { theme } from '../../theme';
import { useIsMobile } from '../../hooks/useMediaQuery';

export default function CloseModal({ typifications, onClose, onSave }) {
  const [typId, setTypId] = useState('');
  const [notas, setNotas] = useState('');
  const isMobile = useIsMobile();

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200,
      padding: isMobile ? '1rem' : 0,
    }}>
      <div style={{
        background: theme.colors.surface, borderRadius: '12px',
        border: `1px solid ${theme.colors.border}`, padding: '1.5rem',
        minWidth: isMobile ? 0 : '340px',
        width: isMobile ? '100%' : undefined, maxWidth: isMobile ? '340px' : undefined,
        boxSizing: 'border-box',
      }}>
        <h3 style={{ color: theme.colors.primary, marginBottom: '1rem', fontSize: '1rem' }}>
          Cerrar conversación
        </h3>
        <label style={{ display: 'block', color: theme.colors.textMuted, fontSize: '0.8rem', marginBottom: '4px' }}>
          Tipificación
        </label>
        <select
          value={typId}
          onChange={(e) => setTypId(e.target.value)}
          style={{
            width: '100%', padding: '8px 10px', borderRadius: '6px',
            background: theme.colors.background, border: `1px solid ${theme.colors.border}`,
            color: theme.colors.text, fontSize: '0.88rem', marginBottom: '12px', boxSizing: 'border-box',
          }}
        >
          <option value="">— Selecciona tipificación —</option>
          {typifications.map((t) => (
            <option key={t.id} value={t.id}>{t.name}</option>
          ))}
        </select>
        <label style={{ display: 'block', color: theme.colors.textMuted, fontSize: '0.8rem', marginBottom: '4px' }}>
          Notas (opcional)
        </label>
        <textarea
          value={notas}
          onChange={(e) => setNotas(e.target.value)}
          rows={3}
          placeholder="Agrega una descripción opcional..."
          style={{
            width: '100%', padding: '8px 10px', borderRadius: '6px', resize: 'vertical',
            background: theme.colors.background, border: `1px solid ${theme.colors.border}`,
            color: theme.colors.text, fontSize: '0.88rem', marginBottom: '14px',
            fontFamily: 'inherit', boxSizing: 'border-box',
          }}
        />
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{
            background: 'transparent', border: `1px solid ${theme.colors.border}`,
            borderRadius: '6px', padding: '7px 16px', cursor: 'pointer', color: theme.colors.textMuted,
          }}>
            Cancelar
          </button>
          <button
            onClick={() => onSave(typId ? parseInt(typId, 10) : null, notas)}
            style={{
              background: theme.colors.primary, border: 'none', borderRadius: '6px',
              padding: '7px 16px', cursor: 'pointer', color: '#0f0f0f', fontWeight: 700,
            }}
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
}
